module.exports = "/_next/static/images/logo_frosted-ef0f829072f8dceab206c8ba76462442.png";